import { FC } from 'react';
import { MenuBarButton } from '../MenuBarButton';
import { MenuOption } from '../../types/menu';
import { FormattedMessage } from 'react-intl';
import {
  useIsFeatureEnabled,
  useIsFeatureEnabledInObject,
} from '../../services/features';

export const MenuItem: FC<MenuOption> = ({
  name,
  to,
  icon,
  feature = '',
  featureByObject,
}) => {
  const enabledByDriver = useIsFeatureEnabled(feature);
  const enabledByObject = useIsFeatureEnabledInObject(feature);

  if (feature && (featureByObject ? !enabledByObject : !enabledByDriver)) {
    return null;
  }

  return (
    <MenuBarButton icon={icon} to={to}>
      <FormattedMessage id={name} />
    </MenuBarButton>
  );
};
